import { atom } from 'jotai';

import { buildAppRegistry, type AppRegistry } from './build-app-registry';
import { contributionModules } from './registry.gen';

/**
 * The composed contribution registry, as the app's queue reads it (OpenSpec
 * `monorepo-shell-registry` task S2 — the dual-source host).
 *
 * Aggregation is pure and happens once at module load: `contributionModules`
 * is a static import list and `buildAppRegistry` has no side effects, so there
 * is nothing to mount and no ordering hazard. The atom exists so the queue can
 * *read* the registry (and so tests can substitute one) — not to hold state.
 *
 * Problems are surfaced rather than thrown: a malformed contribution is
 * already dropped by the aggregator, and CI (`check-shell-contributions`)
 * fails the build on the same report. Logging here would need a logger in a
 * module the whole app imports, so the report stays on the registry object for
 * whoever wants it.
 */
export const appRegistry: AppRegistry = buildAppRegistry(contributionModules);

/**
 * The same aggregation, readable from module scope. Surfaces that resolve a
 * contribution while building a module-level map — settings screen loading — do
 * it before any jotai store exists, and calling `buildAppRegistry` a second
 * time there would make two aggregation sites where duplicate-id detection
 * assumes one.
 */
export const appRegistryAtom = atom<AppRegistry>(appRegistry);
